<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <a-spin type="loading" :spinning="loading">
    <a-card title="نرخ خروج" class="mb-10">
      <div class="grid grid-cols-3 gap-10">
        <a-card class="flex flex-col items-center bg-custom">
          <h5 class="text-center">ماه گذشته</h5>
          <div class="text-center">{{exit.past | toFixed}}</div>
        </a-card>
        <a-card class="flex flex-col items-center bg-custom">
          <h5 class="text-center">ماه جاری</h5>
          <div class="text-center">{{exit.current | toFixed}}</div>
        </a-card>
        <a-card class="flex flex-col items-center bg-custom">
          <h5 class="text-center">ماه آینده</h5>
          <div class="text-center">{{exit.next | toFixed}}</div>
        </a-card>
      </div>
    </a-card>
    <a-card title="منابع انسانی" class="mb-10">
      <h4>جنسیت</h4>
      <div class="grid grid-cols-3 gap-10 mb-10">
        <a-card class="flex flex-col items-center bg-custom">
          <h5 class="text-center">کل</h5>
          <div class="text-center" v-if="chart.index">{{chart.index.count_personnel}}</div>
        </a-card>
        <a-card class="flex flex-col items-center bg-custom">
          <h5 class="text-center">زن</h5>
          <div class="text-center" v-if="chart.index">{{chart.index.count_woman}}</div>
        </a-card>
        <a-card class="flex flex-col items-center bg-custom">
          <h5 class="text-center">مرد</h5>
          <div class="text-center" v-if="chart.index">{{chart.index.count_man}}</div>
        </a-card>
      </div>
      <a-card class="mb-10">
        <h4>تحصیلات</h4>
        <a-table v-if="chart.index" class="mb-10" :data-source="chart.index.ed" :columns="[
          {title: 'تحصیلات',dataIndex: 'last_education_str'},
/*          {title: 'وضعیت مدرک',dataIndex: 'has_certificate_str'},*/
          {title: 'تعداد',dataIndex: 'count'},
          ]"/>
      </a-card>
      <a-card>
        <h4>سن</h4>
          <apexchart type="donut" :key="chartKey" :options="donutChartOptions" :series="donutSeries" height="300px"
                         class="w-full flex justify-center"/>
<!--
        <a-table v-if="chart.index" class="mb-10" :data-source="chart.index.list_age" :columns="[
          {title: 'سن',dataIndex: 'age'},
          {title: 'تعداد',dataIndex: 'count'},
          ]"/>-->

      </a-card>
    </a-card>
    <a-card title="فرایند جذب و نگهداشت" class="mb-10">
      <div class="flex justify-between mb-10">
        <h5>نسبت دعوت به مصاحبه به تعداد رزومه دریافتی</h5>
        <div v-if="chart.proposal">
          {{chart.proposal.ratio_employ_interview | toFixed}}
        </div>
      </div>
      <a-card class="mb-10">
        <h5>نسبت استخدام به مصاحبه</h5>
        <a-table v-if="chart.proposal" :data-source="chart.proposal.ratio_intrview_proposal" :columns="[
          {title: 'شغل',dataIndex: 'title'},
          {title: 'تعداد',dataIndex: 'count',scopedSlots: { customRender: 'count' },},
          ]">
          <span slot="count" slot-scope="text">
            {{text | toFixed}}
          </span>
        </a-table>
      </a-card>
      <a-card>
        <h5>تعداد پرسنل در هر شغل</h5>
        <a-table v-if="chart.proposal" :data-source="chart.proposal.count_job" :columns="[
          {title: 'شغل',dataIndex: 'job_title'},
          {title: 'تعداد',dataIndex: 'count'},
          ]"/>
      </a-card>
    </a-card>
    <div class="grid grid-cols-1 gap-10">
      <div>
        <a-card title="لیست پرسنل اتمام قرارداد در ماه گذشته">
            <x-table @fetch="setExitPast" class="mt-4" :model="contractEndPastMonth"></x-table>
        </a-card>
      </div>
      <div>
        <a-card title="لیست پرسنل اتمام قرارداد در ماه جاری">
          <x-table @fetch="setExitCurrent" :model="contractEndCurrentMonth"></x-table>
        </a-card>
      </div>
      <div>
        <a-card title="لیست پرسنل اتمام قرارداد در ماه آینده">
          <x-table @fetch="setExitNext" :model="contractEndNextMonth"></x-table>
        </a-card>
      </div>
      <div>
        <a-card title="لیست پرسنل استخدام شده در ماه گذشته">
          <x-table :model="PersonelPastMonth">
<!--            <template slot="created_at" slot-scope="text">{{text | jdate}}</template>-->
          </x-table>
        </a-card>
      </div>
      <div>
        <a-card title="لیست پرسنل استخدام شده در ماه جاری">
          <x-table :model="PersonelCurrentMonth">
<!--            <template slot="created_at" slot-scope="text">{{text | jdate}}</template>-->
          </x-table>
        </a-card>
      </div>

      <div>
        <a-card title="لیست پرسنل فسخ قرارداد در ماه گذشته">
          <x-table :model="contractTerminationPastMonth"></x-table>
        </a-card>
      </div>

      <div>
        <a-card title="لیست پرسنل فسخ قرارداد در ماه جاری">
          <x-table :model="contractTerminationCurrentMonth"></x-table>
        </a-card>
      </div>

      <div>
        <a-card title="سوابق کاری">
          <x-table :model="workChart">
            <template slot="count_year" slot-scope="{text, record}">
              {{text?text+' سال':'-'}}
            </template>
            <template slot="end" slot-scope="{text, record}">
              {{record.end_at?record.end_at:'-'}}
            </template>
          </x-table>
        </a-card>
      </div>
    </div>
  </a-spin>
</template>

<script>
  import contractEndPastMonth from './personelEndContractPastmonthTbl';
  import contractEndNextMonth from './personelEndContractNextmonthTbl';
  import contractEndCurrentMonth from './personelEndContractCurrentmonthTbl';
  import PersonelPastMonth from './personelPastmonthTbl';
  import PersonelCurrentMonth from './personelCurrentmonthTbl';
  import contractTerminationCurrentMonth from './contractTerminationCurrentMonthTbl';
  import contractTerminationPastMonth from './contractTerminationPastMonthTbl';
  import workChart from './workChart';
  import XTable from "@/components/new-x-table/XTable";
  import axios from "@/axios"

  import apexchart from 'vue-apexcharts'

  export default {
    data() {
      return {
        contractEndNextMonth,
        contractEndPastMonth,
        contractEndCurrentMonth,
        PersonelCurrentMonth,
        PersonelPastMonth,
        contractTerminationPastMonth,
        contractTerminationCurrentMonth,
        exit: {
          past: undefined,
          current: undefined,
          next: undefined,
        },
        loading: true,
        loadingCounter: 0,
        chart: {
          index:undefined,
          proposal:undefined,
        },
        workChart,
      //  chart
        chartKey: 0,
        donutSeries: [],
        donutChartOptions: {
            chart: {
              type: 'donut',
            },
            labels: ['زیر 22 سال', '22 تا 30 سال', '30 تا 40 سال', '40 تا 50 سال', 'بالاتر از 50 سال'],
            responsive: [{
              breakpoint: 480,
              options: {/*
                chart: {
                  width: 200
                },*/
                legend: {
                  position: 'bottom'
                }
              }
            }]
          }

      //  chart
      }
    },
    components: {
      XTable,
      apexchart
    },
    methods: {
      setExitPast(val) {
        this.exit.past = val.query.exit
        this.loadingCounter++
      },
      setExitCurrent(val) {
        this.exit.current = val.query.exit
        this.loadingCounter++
      },
      setExitNext(val) {
        this.exit.next = val.query.exit
        this.loadingCounter++
      },
    },
    watch: {
      loadingCounter(val) {
        if(val === 3) this.loading = false
      },
    },
    async created() {
      try {
        this.loading = true
        let {data} = await axios.get('chart')
        this.chart.index = data
        this.donutSeries = [
            data.list_age.filter(x => x.age < 22).reduce((partialSum, a) => partialSum + a.count, 0),
            data.list_age.filter(x => x.age >= 22 && x.age < 30).reduce((partialSum, a) => partialSum + a.count, 0),
            data.list_age.filter(x => x.age >= 30 && x.age < 40).reduce((partialSum, a) => partialSum + a.count, 0),
            data.list_age.filter(x => x.age >= 40 && x.age < 50).reduce((partialSum, a) => partialSum + a.count, 0),
            data.list_age.filter(x => x.age > 50).reduce((partialSum, a) => partialSum + a.count, 0),
          ]
          this.chartKey ++
        data = await axios.get('chart/proposal')
        this.chart.proposal = data.data
        this.loading = false
      } catch (e) {
        console.log(e,'eeeeeeeeeeeee')
      }
    },
  }
</script>

<style lang="scss" >
  .bg-custom{
    background: #f5f5f542;
  }
  .ant-pagination
  {
    direction: ltr !important;
  }
  td,th{
    text-align: right !important;
  }
/*  .ant-input-search
  {
    display: none !important;
  }*/

text, .apexcharts-legend-text, .apexcharts-tooltip * {
  font-family: 'p-yek' !important;
}
</style>
